<template>
  <el-dialog
    class="offical-info-modal"
    width="360px"
    title="大库查看"
    v-loading="loading"
    :visible.sync="visible"
    :close-on-press-escape="false"
  >
    <div class="content" v-if="!loading && info && info.cost">
      <div class="left">
        <div class="keys">
          <div class="field">名称：{{ info.partName }}</div>
          <div class="field"></div>
          <div class="field">编号：{{ info.partCode }}</div>
          <div class="field">更新日期：{{ info.priceUpdatedAt | dateFmt }}</div>
          <div class="field">4S含税进价：{{ info.cost | currencyFmt }}</div>
          <div class="field">4S含税售价：{{ info.price | currencyFmt }}</div>
          <div class="field">备注：{{ info.remark }}</div>
        </div>
      </div>
      <div class="right" v-if="warehouses && warehouses.length">
        <div class="c-items">
          <div class="cx" v-for="(item, idx) in warehouses" :key="idx">
            <div class="cl">
              {{ isBenz(info.brandCode) ? item.warehouseName : (item.warehouse && ~item.warehouse.indexOf('库房') && item.city || item.warehouse ||'' ) }}
            </div>
            <div class="cr">
              {{ isBenz(info.brandCode) ? item.count : item.stock }}
            </div>
          </div>
        </div>
      </div>
      <div class="right" style="padding: 10px 0 0 10px" v-if="isBenz(info.brandCode) && (!warehouses || !warehouses.length)">
        {{ info.stock }}{{ (info.stockInfos||'').toString() }}
      </div>
    </div>
    <div class="content" v-else>
      <div class="no-data" v-if="loading" style="width:100%;text-align: center;margin-top: 100px;">查询中，请稍后</div>
      <div class="no-data" v-else style="width:100%;text-align: center;margin-top: 100px;">暂无数据</div>
    </div>
  </el-dialog>
</template>
<script>
import ModalMixin from '@/mixins/modal/modal-mixin'
export default {
  name: 'OfficalInfoModal',
  mixins: [ ModalMixin ],
  data () {
    return {
      loading: false,
      info: {}
    }
  },
  computed: {
    warehouses () {
      let str = this.info.stockInfos || '[]'
      try {
        return JSON.parse(str)
      } catch {
        return []
      }
    }
  },
  methods: {
    init (stockInfo) {
      this.info = stockInfo
      return this.open()
    },
    isBenz (brandCode) {
      return brandCode === 'benz' || brandCode === 'maybach' || brandCode === 'smart'
    }
  }
}
</script>
<style lang="stylus">
.offical-info-modal
  .el-dialog
    max-width 360px
    .el-dialog__header
      padding-top: 10px
      background: #23A8F2
      line-height 1
      color: #fff
      .el-dialog__title
        color: #fff
      .el-dialog__headerbtn
        top: 14px
        i
          color: #fff
    .el-dialog__body
      padding-top 0
      max-height 640px
      overflow-x hidden
      overflow-y auto
      padding: 10px
      .content
        min-height 0
        flex 1
        font-size 12px
        display flex
        align-items stretch
        .left
          min-width 0
          flex 1
          .keys
            padding 8px
            background-color #fff
            .field
              margin-bottom 4px
          .tabs
            display flex
            margin-top 2px
            background-color #f3f3f3
            position relative
            .tab
              line-height 30px
              font-size 12px
              padding 0 10px
              cursor pointer
              &.active
                position relative
                color #0070d2
                &:after
                  content ''
                  position absolute
                  bottom 3px
                  left 50%
                  margin-left -12px
                  width 24px
                  height 4px
                  border-radius 2px
                  background-color #0070d2
          .sec-price
            background-color #fff
            padding 20px 18px 6px
            .p-items
              display flex
              justify-content space-around
              padding-bottom 18px
              .item
                text-align center
                .num
                  color #d13131
                  font-size 18px
                .key
                  color #555
                  font-size 12px
            .ppq
              border-top 1px dashed #dcdcdc
              color #d13131
              padding 8px 0
        .right
          width 116px
          background-color #F0F7FC
          overflow auto
          .c-items
            min-height 0
            flex 1
            padding 0 10px
            .cx
              display flex
              justify-content space-between
              line-height 22px
</style>
